// features/public-filters/domain/mappers/sqftMapper.ts
import { Range } from '../FilterTypes';

/**
 * Parse a square footage display string into a numeric value
 * @param value - Display string like "1000", "No min", "No max"
 * @returns Numeric value or null for unbounded
 */
export function parseSqftValue(value: string): number | null {
  if (value === 'No min' || value === 'No max') return null;
  return parseInt(value) || null;
}

/**
 * Format a numeric square footage value for display
 * @param value - Numeric value or null
 * @param isMin - Whether this is a min or max value
 * @returns Display string
 */
export function formatSqftValue(value: number | null, isMin: boolean): string {
  if (value === null) return isMin ? 'No min' : 'No max';
  return value.toString();
}

/**
 * Apply square footage change from dropdown selection
 * @param currentRange - Current sqft range
 * @param type - Whether changing min or max
 * @param value - New display value from dropdown
 * @returns New Range with updated value
 */
export function applySqftChange(
  currentRange: Range,
  type: 'min' | 'max',
  value: string,
): Range {
  const numericValue = parseSqftValue(value);

  if (type === 'min') {
    return Range.create(numericValue, currentRange.max);
  } else {
    return Range.create(currentRange.min, numericValue);
  }
}
